export const TRANSLATION_SCOPE = 'thiemeCatalogModule';
export const TRANSLATION_GRID_SCOPE = [TRANSLATION_SCOPE, 'grid'];
